import { Box, Link, makeStyles, Typography } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router';

export const ReferralInfoFooter: FunctionComponent = () => {
  const classes = useStyles();
  const history = useHistory();

  const navigateTo = (path: string) => () => {
    history.push(path);
  };

  return (
    <Box marginTop={2}>
      <Typography variant="body2">
        Looking for your referral link?{' '}
        <strong>
          <Link
            href="https://nerva.mindsethealth.com/refer?utm_source=connect"
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
            color="inherit"
            className={classes.link}
          >
            Our HIPAA-compliant webform
          </Link>{' '}
          is now our preferred referral method.{' '}
        </strong>
        <Link
          onClick={navigateTo('/programs/nerva')}
          underline="always"
          color="inherit"
          className={classes.link}
        >
          Your referral link and personalized one pager
        </Link>{' '}
        are still available and you can view your linked patients{' '}
        <Link
          onClick={navigateTo('/linked-patients')}
          underline="always"
          color="inherit"
          className={classes.link}
        >
          here.
        </Link>
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles({
  link: {
    cursor: 'pointer',
  },
});
